<template>
  <div class="comboRecipe">
    <el-button icon="el-icon-refresh" @click="$refresh(getComboRecipeList)" class="refresh-btn">刷新</el-button>
    <div class="combowrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="处方名称">
            <el-input v-model.trim="searchForm.comboName" placeholder="请输入隐秘处方名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getComboRecipeList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getComboRecipeList, { comboName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addComboRecipe">新增隐秘处方</el-button>
        <!-- <el-button icon="el-icon-delete" type="danger" @click="deleteComboRecipeList">批量删除处方</el-button> -->
      </div>
      <!-- 处方列表 -->
      <el-table v-loading="loading" :max-height="tableHeight" :data="comboRecipeList"
        ref="multipleTable" @selection-change="val => $handleSelectionChange(val, true)" border>
        <!-- <el-table-column type="selection" width="50"/> -->
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="form-props">
              <el-form-item label="处方名称">
                <span><b>{{ props.row.comboName }}</b></span>
              </el-form-item>
              <el-form-item label="药品明细" class="drug">
                <div v-for="item in props.row.comboItems" :key="item.artNo" class="drugItem">
                  {{item.drugName}} {{item.number}} {{item.unit}}，单价： <b>{{item.price}}</b> 元/{{item.unit}}，小计：{{item.totalPrice}} 元
                </div>
              </el-form-item>
              <el-form-item label="处方总价">
                <span><b>{{ props.row.price }}</b></span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="comboName" label="处方名称" min-width="160"/>
        <el-table-column prop="price" label="处方总价" min-width="100"/>
        <el-table-column prop="updateBy" label="操作员" min-width="100"/>
        <el-table-column prop="updateTime" label="更新时间" min-width="160"/>
        <el-table-column label="操作" width="230">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editComboRecipe(scope.row)" >编辑处方</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deleteComboRecipe(scope.row)" >删除处方</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="comboEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="700px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" label-width="80px" inline>
          <el-form-item label="处方名称" prop="comboName" :rules="[{required: true, message: '隐秘处方名称不能为空！'}]">
            <el-input v-model.trim="editForm.comboName" clearable placeholder="隐秘处方名称"/>
          </el-form-item>
          <el-form-item label="选择药品">
            <el-button type="primary" @click="addProcess" :disabled="processDisable" icon="el-icon-plus" class="fr">添加加工</el-button>
            <el-select v-model="editForm.drugId" :remote-method="getDrugsList" filterable remote
              default-first-option placeholder="请输入关键字查询并选择药品" @change="addDrug">
              <el-option v-for="item in drugOptions" :key="item.drugId" :value="item.drugId" :label="item.drugName" :disabled="item.disabled">
                <span class="fl">{{ item.drugName }}</span>
                <span class="select-flex">
                  <span class="ml20">{{item.type}}</span>
                  <span class="ml20">{{ item.manufacturer }}</span>
                  <span class="ml20">{{item.price}} 元 / {{item.unit}}</span>
                  <span class="ml20">余 {{item.inventory}} {{item.unit}}</span>
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目列表" prop="comboItems" :rules="[{required: true}]">
            <el-table :data="editForm.comboItems" class="combo-items-box" border>
              <el-table-column prop="drugName" label="药品/加工" width="100"/>
              <el-table-column prop="number" label="数量">
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.number" :disabled="scope.row.disable" @change="val => numberChange(val, scope.row)"/>
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="单位"/>
              <el-table-column prop="price" label="单价">
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.price" @change="val => priceChange(val, scope.row)"/>
                </template>
              </el-table-column>
              <el-table-column prop="totalPrice" label="小计">
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.totalPrice" @change="val => totalPriceChange(val, scope.row)"/>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="danger" @click="delItem(scope.row)" icon="el-icon-delete">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="处方总价" prop="price" :rules="[{required: true}]">
            <el-input v-model.trim="editForm.price" disabled/>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addSave" v-show="dialogTitle == '新增隐秘处方'">保存新增</el-button>
          <el-button type="success" @click="editSave" v-show="dialogTitle == '编辑隐秘处方'">保存编辑</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getComboRecipeList)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { comboRecipeList, comboRecipeAdd, comboRecipeDelete, comboRecipeDetails, comboRecipeEdit } from "@/api/combo"; // 隐秘处方请求
import { drugList } from "@/api/drug"; // 药品请求
export default {
  data() {
    return {
      loading: true, // 加载中
      searchForm: { comboName: null }, // 查询表单
      editForm: {}, // 新增表单
      comboRecipeList: [], // 药品列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogVisible: false,
      dialogTitle: '', // 弹框题目
      multipleSelection: [], // 多选集合
      drugOptions: [], // 药品列表
      tableHeight: 0, // 表格最大高度
      processDisable: false, // 是否可选加工
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getComboRecipeList(); // 获取隐秘处方列表
  },
  methods: {
    // 请求药品列表
    async getDrugsList(query) {
      if (query != '' && query != null) {
        this.drugOptions = [];
        let { rows, code } = await drugList({searchValue: query, deptId: this.$session.get('deptId')});
        if (code == 200) {
          rows.forEach(item => {
            item.disabled = false;
            this.editForm.comboItems.forEach(kid => { 
              if (item.drugId == kid.drugId) item.disabled = true;
            });
            if (item.drugName.indexOf('过滤袋') == -1) this.drugOptions.push(item);
          });
        }
      }
    },
    // 请求隐秘处方列表
    async getComboRecipeList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await comboRecipeList(params);
      
      if (code == 200) {
        this.total = total;
        this.comboRecipeList = rows;
      }
      this.loading = false;
    },
    // 删除隐秘处方
    deleteComboRecipe(row) {
      this.$confirm('确认删除该隐秘处方？').then(_ => { this.del(row.comboId) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await comboRecipeDelete(id);
      if (code == 200) this.$message.success("删除隐秘处方成功！");
      this.$refresh(this.getComboRecipeList);
    },
    // 批量删除隐秘处方
    deleteComboRecipeList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何隐秘处方！");
      else {
        selected.forEach(item => { selectedId.push(item.comboId) });
        this.$confirm('确认删除该隐秘处方？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    },
    // 添加药品
    addDrug(val) {
      this.drugOptions.forEach(item => {
        if (item.drugId == val) {
          this.editForm.comboItems.push({
            drugName: item.drugName, unit: item.unit, number: 1, price: item.price,
            totalPrice: item.price, artNo: item.id, disable: false
          });
        }
      })
      this.editForm.drugId = null;
      this.drugOptions = [];
      this.computeTotalPrice();
    },
    // 添加加工
    addProcess() {
      this.editForm.comboItems.push({drugName: '加工费', unit: '次', number: 1, price: 0, totalPrice: 0, artNo: 0, disable: true});
      this.processDisable = true;
    },
    // 删除项目
    delItem(obj) {
      if (obj.artNo == 0) this.processDisable = false;
      let index = 0;
      this.editForm.comboItems.forEach((item, i) => {
        if (obj.artNo == item.artNo) index = i;
      });
      this.editForm.comboItems.splice(index, 1);
      this.computeTotalPrice();
    },
    // 数量改变
    numberChange(val, obj) {
      obj.totalPrice = this.$toFixed((val * obj.price));
      this.computeTotalPrice();
    },
    // 单价改变
    priceChange(val, obj) {
      obj.totalPrice = this.$toFixed((val * obj.number));
      this.computeTotalPrice();
    },
    // 小计改变
    totalPriceChange(val, obj) {
      obj.price = this.$toFixed((val / obj.number));
      this.computeTotalPrice();
    },
    // 计算总价
    computeTotalPrice() {
      this.editForm.price = 0;
      this.editForm.comboItems.forEach(item => {
        this.editForm.price += item.number * item.price;
      });
      this.editForm.price = this.$toFixed(this.editForm.price);
    },
    // 新增隐秘处方
    addComboRecipe() {
      this.dialogVisible = true;
      this.dialogTitle = '新增隐秘处方';
      this.editForm = { comboName: null, comboItems: [], price: 0, drugId: null };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          comboRecipeAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增隐秘处方成功！");

            this.dialogVisible = false;
            this.$refresh(this.getComboRecipeList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      });
    },
    // 编辑处方
    async editComboRecipe(row) {
      let { code, data } = await comboRecipeDetails(row.comboId);
      if (code == 200) {
        data.drugId = null;
        data.comboItems.forEach(item => {
          if (item.artNo == 0) {
            item.disable = true;
            this.processDisable = true;
          } else item.disable = false;
        });
        this.editForm = data;
        this.dialogTitle = '编辑隐秘处方';
        this.dialogVisible = true;
      }
    },
    // 保存编辑
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          comboRecipeEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("编辑隐秘处方成功！");

            this.dialogVisible = false;
            this.$refresh(this.getComboRecipeList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>

<style lang="less" scoped>
  .comboRecipe {
    box-sizing: border-box;
    padding: 20px;
  }

.combowrap {
  & > div:not(:last-child) {
    margin-bottom: 20px;
  }
  /* 弹框样式 */
  .comboEdit {
    .el-form-item {
      width: 660px;
      .el-input {
        width: 580px;
      }
      .el-select {
        width: 472px;
        margin-right: 10px;
      }
    }
    .combo-items-box {
      width: 580px;
      .el-input {
        width: 72px;
      }
    }
  }
  /* 表格下拉样式 */
  /deep/.el-table__expanded-cell {
    padding: 20px;
  }
  .form-props {
    border: 1px solid #999;
    .el-form-item {
      display: block;
      margin: 0;
      display: flex;
      &:not(:last-child) {
        border-bottom: 1px solid #999;
      }
      /deep/.el-form-item__label {
        width: 70px;
        padding: 0 10px;
        font-size: 12px;
        text-align: right;
        border-right: 1px solid #999;
      }
      /deep/.el-form-item__content {
        flex: 1;
        padding: 0 10px;
        font-size: 12px;
      }
      &.drug {
        /deep/.el-form-item__content {
          display: flex;
          flex-wrap: wrap;
          padding: 0 10px 10px;
          .drugItem {
            width: 300px;
            margin-right: 20px;
            border-bottom: 1px dashed #999;
          }
        }
      }
    }
  }
}
</style>